import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabBase } from '@core/base/tab.base';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-user-access-control-tab',
  templateUrl: './user-access-control-tab.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UserAccessControlTabComponent extends TabBase {
  hasUpdates$ = new BehaviorSubject(false);

  constructor() {
    super(inject(ActivatedRoute).parent!);
  }

  hasRolesUpdated(hasUpdatedRoles: boolean): void {
    this.hasUpdates$.next(hasUpdatedRoles);
  }
}
